module.exports = __webpack_public_path__ + "img/image-031.3a4a7eba.png";